import type { AccessPair } from '@/shared/lib'

/**
 * `/v1/notifications**` — своя лента учётной записи. Право ручки — `notification.view`
 * (`docs/roles/02-backend-contract.md`); модификатора контекста ручка не принимает (`400`),
 * поэтому пара только `own`.
 */
export const NOTIFICATIONS_ACCESS: AccessPair = { own: 'notification.view' }
